<template>
  <Pie
    v-bind:data="data"
    v-bind:options="options"
    v-bind:style="styles" />
</template>
<script>
  // DataPage.vue
  import { Chart as ChartJS, ArcElement, Legend } from 'chart.js';
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  import { Pie } from 'vue-chartjs';
  ChartJS.register(ChartDataLabels, ArcElement, Legend);
  export default {
    name: 'pie-chart',
    components: { Pie },
    props: ['chart_data', 'chart_options', 'styles'],
    data() {
      return {
        data: this.chart_data,
        options: {
          responsive: true,
          plugins: {
            datalabels: {
              formatter: (value, ctx) => {
                const datasets = ctx.chart.data.datasets;

                let percentage = 0;

                if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
                  const sum = datasets[0].data.reduce((a, b) => a + b, 0);

                  percentage = (value / sum) * 100 + '%';

                  return percentage;
                } else {
                  return percentage;
                }
              },
              color: 'white',
              textStrokeColor: 'black',
              textStrokeWidth: 1,
              textAlign: 'center',
              font: {
                weight: 'bold',
                size: 12
              }
            }
          },
          ...this.chart_options
        }
      };
    }
  };
</script>
